<template>
    <div class="compo-form-item" :class="{'secret': isSecret}">
        <div class="compo-form-name">
            <label class="compo-form-title" :class="{'w-auto': isSecret}">
                <!-- 주문내역 -->
                <template v-if="productItem.opId">쿠폰정보</template>
                <!-- 주문/결제 -->
                <template v-else><i v-if="isSecret" class="txt-mr-1">시크릿가</i>상품정보</template>
            </label>            
            <a class="form-title-right" data-bs-toggle="collapse" href="#order-product-collapse" role="button" aria-expanded="true" aria-controls="order-product-collapse">
                <p class="txt-preview">{{productItem.goodsNm}}</p>
                <img class="collapse-icon" src="@/assets/img/icon_down.svg" alt="드롭다운 화살표">
            </a>
        </div>
        <div class="collapse show" id="order-product-collapse">
            <div class="compo-form-body d-flex flex-row">
                <figure class="order-product-thumb">
                    <template v-if="isSecret && !isSecretValid">
                        <span><img :src="`${productItem.goodsImgPath}`" :alt="`${productItem.goodsNm}`"></span>
                    </template>
                    <template v-else>
                        <router-link v-bind:to="`/details/${productItem.goodsId}`">
                            <img :src="`${productItem.goodsImgPath}`" :alt="`${productItem.goodsNm}`">
                        </router-link>
                    </template>
                </figure>
                <div class="order-product">
                    <p class="brand" aria-label="상품 카테고리">{{productItem.brdNm}}</p>
                    <p class="title" aria-label="상품명">
                        <template v-if="isSecret && !isSecretValid">
                            <span>{{productItem.goodsNm}}</span>
                        </template>
                        <template v-else>
                            <router-link v-bind:to="`/details/${productItem.goodsId}`">
                                {{productItem.goodsNm}}
                            </router-link>
                        </template>    
                    </p>
                    <p class="product-price" aria-label="가격">
                        <template v-if="isSecret && !isSecretValid">
                            <span>
                                <template v-if="isSecret">
                                    <ins class="discount-price color-secret" aria-label="시크릿가">{{Number(productItem.goodsPricePoc).toLocaleString()}}원</ins>
                                </template>
                                <template v-else>
                                    <ins class="discount-price" :aria-label="{'할인가': isSale}">{{Number(productItem.goodsPricePoc).toLocaleString()}}원</ins>
                                </template>
                                <template v-if="isSale || isSecret">
                                    <del class="origin-price" aria-label="정상가">{{Number(productItem.goodsPriceMarket).toLocaleString()}}원</del>
                                </template>
                            </span>
                        </template>
                        <template v-else>
                            <router-link v-bind:to="`/details/${productItem.goodsId}`">
                                <template v-if="isSecret">
                                    <ins class="discount-price color-secret" aria-label="시크릿가">{{Number(productItem.goodsPricePoc).toLocaleString()}}원</ins>
                                </template>
                                <template v-else>
                                    <ins class="discount-price" :aria-label="{'할인가': isSale}">{{Number(productItem.goodsPricePoc).toLocaleString()}}원</ins>
                                </template>
                                <template v-if="isSale || isSecret">
                                    <del class="origin-price" aria-label="정상가">{{Number(productItem.goodsPriceMarket).toLocaleString()}}원</del>
                                </template>
                            </router-link>
                        </template>
                    </p>
                </div>
            </div>
            <!-- 시크릿가의 경우 만료일, 수량 노출 -->
            <div class="compo-form-body form-body__secret-expiration" v-if="isSecret">
                <p class="secret-expiration">
                    <template v-if="productItem.validEndDate">
                        <span class="secret-expiration-key">시크릿가 기간</span>
                        <span class="secret-expiration-value color-warning">~ {{this.productItem.validEndDate}}까지 주문가능</span>
                    </template>
                </p>
                <p class="secret-expiration">
                    <span class="secret-expiration-key">시크릿가 주문 가능 수량</span>
                    <span class="secret-expiration-value">{{this.productItem.limitCnt}}개 남음</span>
                </p>
            </div>
            <!-- 주문내역에서 노출 -->
            <div class="compo-form-body bd" v-if="$route.name.match('order-history-detail')">            
                <table class="key-value value-left">
                    <tr>
                        <th>유효기간</th>
                        <td>{{productItem.validDate}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    components: { 
    
    },

    props: {
        productItem : {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            goodsId: null,
            product: [],
            useInfoTxt: null,
            goodsInfoTxt: null,
            // isSale: false,      // 할인 여부 = (정상가 - 할인가) > 0
            // isSecret: true,     // 시크릿가 여부
        }
    },

    computed: {
        ...mapState({
            userNo: state => state.userNo,
        }),

        isSale(){ // 할인 여부: (정상가 - 할인가) > 0 === true
            return (this.productItem.goodsPriceMarket - this.product.goodsPricePoc) > 0; 
        },

        isSecret(){ // 시크릿가 여부
            return this.productItem.secretGoodsYn === 'Y' ? true : false ; 
        },

        isSecretValid(){ // 시크릿가 만료여부 여부
            return this.productItem.isSecretGoodsValid === 'Y' ? true : false ; 
        },
    },

    created() {
        
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/order.scss';

.txt-mr-1{
    margin-right: 5px;
}
.form-body__secret-expiration{
    padding-top: 8px;

    .secret-expiration-key{
        font-size: 12px;
    }
    .secret-expiration-value{
        font-size: 13px;
    }
}
</style>